import axios, { AxiosError, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import { loadState } from 'utils/LocalStorage';
import { IError } from 'types';
import { getURLParameter } from 'utils/nativeSupport';

const Request = axios.create({
	baseURL: '/api/v1',
	headers: { 'Content-Type': 'application/json' },
});
const Request1 = axios.create({
	baseURL: '/api/v1',
	headers: { 'Content-Type': 'application/json' },
});

const RequestMerchant = axios.create({
	baseURL: '/api/v1',
	headers: { 'Content-Type': 'application/json' },
});

const RequestMplugin = axios.create({
	baseURL: '/api/v1',
	headers: { 'Content-Type': 'application/json' },
});

const serializeError = (error: AxiosError): IError => {
	const { response } = error;
	if (!response) throw error;
	const { status, statusText, data } = response;
	const { message } = data;
	let errorMsg = '';
	try {
		errorMsg = JSON.parse(message).error.debug_msg;
	} catch (e) {
		errorMsg = message;
	}
	const errorObj = {
		name: 'API ERROR',
		message: errorMsg || statusText || `API FAILED (${status})`,
		code: status.toString(),
		stack: JSON.stringify(error.toJSON()),
	};
	return errorObj;
};

const tokenHeaderInterceptor = (config: AxiosRequestConfig): AxiosRequestConfig => {
	const IsPgWebMode = getURLParameter(window.location.href, 'IsPgWebMode') || '';
	const appInfoParsed: any = loadState('APP_INFO');
	const Token =
		getURLParameter(window.location.href, 'token') ||
		getURLParameter(window.location.href, 'visa') ||
		appInfoParsed?.token ||
		'';
	const Entity = getURLParameter(window.location.href, 'entity') || '';
	if (IsPgWebMode) {
		config.headers['device'] = 'web';
		if (config?.url?.includes('method/webview/')) {
			config.headers['Token'] = Token;
			config.headers['Entity'] = Entity;
		}
		return config;
	}
	const device = getURLParameter(window.location.href, 'deviceId') || appInfoParsed?.deviceId || '';
	const simId = getURLParameter(window.location.href, 'simId') || appInfoParsed?.simId || '';
	const installId = getURLParameter(window.location.href, 'installId') || appInfoParsed?.installId || '';
	config.headers['Authorization'] = `bearer ${Token}`;
	config.headers['Token'] = Token;
	config.headers['Entity'] = Entity;
	config.headers['device'] = device;
	config.headers['simid'] = simId;
	config.headers['installid'] = installId;
	return config;
};

const tokenHeaderInterceptor1 = (config: AxiosRequestConfig): AxiosRequestConfig => {
	const appInfoParsed: any = loadState('APP_INFO');
	const Token =
		getURLParameter(window.location.href, 'token') ||
		getURLParameter(window.location.href, 'visa') ||
		appInfoParsed?.token ||
		'';
	const Entity = getURLParameter(window.location.href, 'entity') || '';
	const device = getURLParameter(window.location.href, 'deviceId') || appInfoParsed?.deviceId || '';
	const simId = getURLParameter(window.location.href, 'simId') || appInfoParsed?.simId || '';
	const installId = getURLParameter(window.location.href, 'installId') || appInfoParsed?.installId || '';

	config.headers['Authorization'] = `bearer ${Token}`;
	config.headers['Token'] = Token;
	config.headers['Entity'] = Entity;
	config.headers['device'] = device;
	config.headers['simid'] = simId;
	config.headers['installid'] = installId;
	return config;
};

const tokenHeaderInterceptorMerchant = (config: AxiosRequestConfig): AxiosRequestConfig => {
	const appInfoParsed: any = loadState('APP_INFO');
	const Token =
		getURLParameter(window.location.href, 'token') ||
		getURLParameter(window.location.href, 'visa') ||
		appInfoParsed?.token ||
		'';

	config.headers['Authorization'] = `Bearer ${Token}`;
	config.headers['Token'] = Token;
	return config;
};

const tokenHeaderInterceptorMplugin = (config: AxiosRequestConfig): AxiosRequestConfig => {
	const appInfoParsed: any = loadState('APP_INFO');
	const Token =
		getURLParameter(window.location.href, 'token') ||
		getURLParameter(window.location.href, 'visa') ||
		appInfoParsed?.token ||
		'';
	const Entity = getURLParameter(window.location.href, 'entity') || 'MERCHANT';

	config.headers['Authorization'] = `Bearer ${Token}`;
	config.headers['Token'] = Token;
	config.headers['Entity'] = Entity;
	return config;
};

const onErrorInterceptor = (error: AxiosError): IError => {
	throw serializeError(error);
};

Request.interceptors.request.use(tokenHeaderInterceptor);
Request.interceptors.response.use(undefined, onErrorInterceptor);

Request1.interceptors.request.use(tokenHeaderInterceptor1);
Request1.interceptors.response.use(undefined, onErrorInterceptor);

RequestMerchant.interceptors.request.use(tokenHeaderInterceptorMerchant);
RequestMerchant.interceptors.response.use(undefined, onErrorInterceptor);

RequestMplugin.interceptors.request.use(tokenHeaderInterceptorMplugin);
RequestMplugin.interceptors.response.use(undefined, onErrorInterceptor);

interface IAPIResponse<T> {
	success: boolean;
	message: string;
	data: T;
}

const extractor = <T,>(response: AxiosResponse<IAPIResponse<T>>) => {
	const { status, data, statusText } = response;
	if (status !== 200) throw new Error(statusText);
	// if (!data || !data.success) throw new Error(data.message);
	return data.data;
};

const extractor1 = <T,>(response: AxiosResponse<IAPIResponse<T>>) => {
	const { status, statusText } = response;
	if (status !== 200) throw new Error(statusText);
	return response.data;
};

const extractor2 = <T,>(response: AxiosResponse<any>) => {
	const { status, data, statusText } = response;
	if (status !== 200) throw new Error(statusText);
	return { ...data.data, ...{ status_code: data.statusCode, api_msg: data.msg || data.message } };
};

const extractor3 = <T,>(response: AxiosResponse<T>) => {
	const { status, data, statusText } = response;
	if (![200, 204].includes(status)) throw new Error(`${statusText}${data?.message || ''}`);
	return data;
};

export interface IGetParams {
	[field: string]: string | number;
}

export const Get = <T,>(path: string, params?: Partial<IGetParams>, cancelToken?: CancelToken): Promise<T> =>
	Request.get<IAPIResponse<T>>(path, { params, cancelToken }).then(extractor);

export const Get2 = <T,>(path: string, params?: Partial<IGetParams>, cancelToken?: CancelToken): Promise<T> =>
	Request.get<T>(path, { params, cancelToken }).then(extractor3);

export const Get3 = <T,>(path: string, params?: Partial<IGetParams>, cancelToken?: CancelToken): any =>
	Request.get(path, { params, cancelToken }).then(extractor1);

export const GetMerchant = <T,>(path: string, params?: Partial<IGetParams>, cancelToken?: CancelToken): Promise<T> =>
	RequestMerchant.get<IAPIResponse<T>>(path, { params, cancelToken }).then(extractor);

export const GetMplugin = <T,>(path: string, params?: Partial<IGetParams>, cancelToken?: CancelToken): any =>
	RequestMplugin.get<IAPIResponse<T>>(path, { params, cancelToken }).then(extractor1);

export const GetCardInfo = <T,>(path: string, params?: Partial<IGetParams>, cancelToken?: CancelToken): any =>
	Request.get(path, { params, cancelToken }).then(extractor1);

export const Post = <T,>(path: string, payload: unknown, cancelToken?: CancelToken): Promise<T> =>
	Request.post<IAPIResponse<T>>(path, payload, { cancelToken }).then(extractor);

export const PostMplugin = <T,>(path: string, payload: unknown, cancelToken?: CancelToken): any =>
	RequestMplugin.post<IAPIResponse<T>>(path, payload, { cancelToken }).then(extractor1);

export const PostJuspay = <T,>(path: string, payload: unknown, cancelToken?: CancelToken): Promise<T> =>
	Request.post<IAPIResponse<T>>(path, payload, { cancelToken }).then(extractor2);

export const Put = <T,>(path: string, payload: unknown, cancelToken?: CancelToken): Promise<T> =>
	Request.put<IAPIResponse<T>>(path, payload, { cancelToken }).then(extractor);

export const GetPostpeUat = <T,>(path: string, params?: Partial<IGetParams>, cancelToken?: CancelToken): Promise<T> =>
	Request1.get<IAPIResponse<T>>(path, { params, cancelToken }).then(extractor);

export const PutPostpeUat = <T,>(path: string, payload: unknown, cancelToken?: CancelToken): Promise<T> =>
	Request1.put<IAPIResponse<T>>(path, payload, { cancelToken }).then(extractor);

export const PutMplugin = <T,>(path: string, payload: unknown, cancelToken?: CancelToken): any =>
	RequestMplugin.put<IAPIResponse<T>>(path, payload, { cancelToken }).then(extractor1);
